import React, { useEffect, useState } from "react";
import {
  Container,
  Box,
  Typography,
  Grid,
  Divider,
  Button,
} from "@mui/material";
import { Link } from "react-router-dom";
// import Logo from 'src/@core/components/logo'
import { styled } from "@mui/system";
import { useTranslation } from "react-i18next";

import { axiosInstance } from "src/network/adapter";
import { ApiEndpoints } from "src/network/endpoints";
import { toastError } from "src/utils/utils";
import Logo from "src/@core/components/logo";
import googleIcon from "../../assets/images/googleIcon.svg";
import facebookIcon from "../../assets/images/facebookIcon.svg";
import linkedinIcon from "../../assets/images/linkedinIcon.svg";
import twitterIcon from "../../assets/images/twitterIcon.svg";
import logoImg from "../../assets/images/logo.svg";

const Footer = () => {
  const { t } = useTranslation();

  const quickLinks = [
    {
      title: t("Home"),
      path: "/",
    },
    {
      title: t("Services"),
      path: "/services",
    },

    {
      title: t("Driver Application"),
      path: "/driver-application",
    },
    {
      title: t("About Us"),
      path: "/about-us",
    },
    {
      title: t("Blog"),
      path: "/blog",
    },
    {
      title: t("Contact Us"),
      path: "/contact-us",
    },
  ];

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top when the component mounts
  }, []);
  const currentYear = new Date().getFullYear();
  return (
    <>
      <Box>
        <Divider sx={{ borderBottomWidth: 4, color: "#E8E8E8" }} />
        <Container maxWidth="lg" sx={{ py: 8 }}>
          <Grid container sx={{ px: { xs: 5, md: 0 } }} rowGap={6}>
            <Grid
              item
              xs={12}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Box
                sx={{ height: "72px", width: "193px" }}
                component={Link}
                to={"/"}
              >
                <img src={logoImg} style={{ height: "100%", width: "100%" }} />
              </Box>
            </Grid>
            <Grid item container>
              <Grid
                item
                xs={12}
                md={7}
                sx={{ display: "flex", flexDirection: "column", gap: 8 }}
              >
                <Typography
                  sx={{
                    fontSize: { sm: "18px" },
                    lineHeight: { sm: "18px" },
                    fontWeight: 600,
                    letterSpacing: "1px",
                    color: "#000000",
                  }}
                >
                  {t("QUICK LINKS")}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    // flexDirection: { xs: "column", md: "row" },
                    alignItems: { md: "center" },
                    gap: { xs: 5, md: 10 },
                    // flexWrap: { md: "wrap", lg: "nowrap" },
                    flexWrap: "wrap",
                    "@media (min-width:900px)": {
                      flexWrap: "nowrap", // set flexWrap to nowrap starting at 900px
                    },
                    flexDirection: "column",
                    "@media (min-width:900px)": {
                      flexDirection: "row", // set flexWrap to nowrap starting at 900px
                    },
                  }}
                >
                  {quickLinks.map((item, index) => (
                    <Link
                      to={item.path}
                      key={index}
                      style={{ textDecoration: "none" }}
                    >
                      <Typography
                        sx={{
                          fontSize: "14px",
                          lineHeight: { sm: "24px" },
                          fontWeight: 500,
                          color: "#7A7B7B",
                          textWrap: "nowrap",
                        }}
                      >
                        {item.title}
                      </Typography>
                    </Link>
                  ))}
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                md={5}
                sx={{
                  display: "flex",
                  justifyContent: { xs: "start", md: "end" },
                  mt: { xs: 10, md: 0 },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",

                    gap: 8,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: { sm: "18px" },
                      lineHeight: { sm: "18px" },
                      fontWeight: 600,
                      letterSpacing: "1px",
                      color: "#000000",
                    }}
                  >
                    {t("FOLLOW US ON")}
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <img src={googleIcon} alt="google" />
                    <img src={facebookIcon} alt="facebook" />
                    <img src={linkedinIcon} alt="linkedin" />
                    <img src={twitterIcon} alt="twitter" />
                  </Box>
                </Box>
              </Grid>
            </Grid>
            <Grid item xs={12} pt={6}>
              <Divider sx={{ color: "#AAAAAA" }} />
            </Grid>
            <Grid item container>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontSize: "16px",
                    fontWeight: 500,
                    lineHeight: "24px",
                    color: "#5E5E5E",
                  }}
                >
                  {t(`© Copyright ${currentYear}, All Rights Reserved`)}
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: { xs: "start", md: "end" },
                  gap: 7,
                  mt: { xs: 3, md: 0 },
                }}
              >
                <Link style={{ textDecoration: "none" }} to={"/privacy-policy"}>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: 500,
                      lineHeight: "24px",
                      color: "#5E5E5E",
                    }}
                  >
                    {t("Privacy Policies")}
                  </Typography>
                </Link>
                <Link
                  style={{ textDecoration: "none" }}
                  to={"/terms-and-conditions"}
                >
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: 500,
                      lineHeight: "24px",
                      color: "#5E5E5E",
                    }}
                  >
                    {t("Terms & Conditions")}
                  </Typography>
                </Link>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default Footer;
